<div>
  <div class="title">
    <h1>{{'View/Edit Monthly Hours' | translate | async}}</h1>
  </div>
  <div class="selection">  
    <mat-form-field>
      <mat-select (selectionChange)="loadMonthlyHours()" placeholder="{{'State' | translate | async}}"   [(ngModel)]="inputValuestate" name="Site" [formControl]="state" required>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select>  
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
  </mat-form-field>

    <mat-form-field>
      <mat-select (selectionChange)="loadMonthlyHours()" placeholder="Select Year" [(ngModel)]="selectedyear" name="selectedyear_" [value]="selectedyear"> 
        <mat-option [value]="2019">2019</mat-option>
        <mat-option [value]="2020">2020</mat-option>
        <mat-option [value]="2021">2021</mat-option>
        <mat-option [value]="2022">2022</mat-option>
        <mat-option [value]="2023">2023</mat-option>
        <mat-option [value]="2024">2024</mat-option>
        <mat-option [value]="2025">2025</mat-option>
        <mat-option [value]="2026">2026</mat-option>
        <mat-option [value]="2027">2027</mat-option>
        <mat-option [value]="2028">2028</mat-option>
        <mat-option [value]="2029">2029</mat-option>
        <mat-option [value]="2030">2030</mat-option>
      </mat-select>
    </mat-form-field>
    </div>
  
<div class="details">
  <mat-form-field class="DBSS">    
    <input matInput type="number" min="0" placeholder="{{'January' | translate | async}}" [(ngModel)]= "HoursforJanuary" name="_month">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateJanuary()" mat-raised-button [disabled]="state.hasError('required')">
    {{'Update' | translate | async}}
  </button>
</div>
  
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'February' | translate | async}}" min="0" [(ngModel)]= "HoursforFebruary" >   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateFebruary()" mat-raised-button [disabled]="state.hasError('required')">
    <!-- <button mat-stroked-button> -->
    {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'March' | translate | async}}" min="0"[(ngModel)]= "HoursforMarch">   
  </mat-form-field>
  <!-- <button mat-stroked-button (click) = "UpdateFebruary()"> -->
    <button mat-raised-button (click)="UpdateMarch()" mat-raised-button [disabled]="state.hasError('required')">
    {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
  
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'April' | translate | async}}" min="0"[(ngModel)]= "HoursforApril">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateApril()" mat-raised-button [disabled]="state.hasError('required')">
    {{'Update' | translate | async}}
  </button>
</div>
   
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'May' | translate | async}}" min="0"[(ngModel)]= "HoursforMay">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateMay()" mat-raised-button [disabled]="state.hasError('required')">
    {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
  
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'June' | translate | async}}" min="0" [(ngModel)]= "HoursforJune">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateJune()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'July' | translate | async}}" min="0" [(ngModel)]= "HoursforJuly">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateJuly()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
<div class="details">

  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'August' | translate | async}}" min="0" [(ngModel)]= "HoursforAugust">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateAugust()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'September' | translate | async}}" min="0" [(ngModel)]= "HoursforSeptember">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateSep()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'October' | translate | async}}" min="0" [(ngModel)]= "HoursforOctober">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateOct()" mat-raised-button [disabled]="state.hasError('required')">
       {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
  
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'November' | translate | async}}" min="0" [(ngModel)]= "HoursforNovember">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateNov()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
<div class="details">
 
  <mat-form-field class="DBSS">
    <input matInput type="number" placeholder="{{'December' | translate | async}}" min="0" [(ngModel)]= "HoursforDecember">   
  </mat-form-field>
  <button mat-raised-button (click)="UpdateDec()" mat-raised-button [disabled]="state.hasError('required')">
        {{'Update' | translate | async}}
  </button>
</div>
     
     
      